import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { ScrollToTop } from './components/ScrollToTop';
import { FloatingCTA } from './components/FloatingCTA';

import { Home } from './pages/Home';
import { WhoWeAre } from './pages/WhoWeAre';
import { MidtgaardenPage } from './pages/MidtgaardenPage';
import { StaffPage } from './pages/StaffPage';
import { PracticalInfoPage } from './pages/PracticalInfoPage';
import { TreatmentOverviewPage } from './pages/TreatmentOverviewPage';
import { TreatmentDetailPage } from './pages/TreatmentDetailPage';
import { DobbeltdiagnosePage } from './pages/DobbeltdiagnosePage';
import { AfgiftningPage } from './pages/AfgiftningPage';
import { BotilbudPage } from './pages/BotilbudPage';
import { ApprovalsAndTilsynPage } from './pages/ApprovalsAndTilsynPage';
import { PricesPage } from './pages/PricesPage';
import { ParagrafPage } from './pages/ParagrafPage';
import { CitizenPage } from './pages/CitizenPage';
import { ProfessionalPage } from './pages/ProfessionalPage';
import { SejstrupPage } from './pages/SejstrupPage';
import { EsbjergPage } from './pages/EsbjergPage';
import { RulesPage } from './pages/RulesPage';
import { NotFoundPage } from './pages/NotFoundPage';
import { ForbiddenPage } from './pages/ForbiddenPage';

export default function App() {
  return (
    <HelmetProvider>
      <ScrollToTop />
      <div className="flex flex-col min-h-screen bg-[#F8FAFC] text-[#1C1C1E] selection:bg-[#3885B8] selection:text-white">
        <Header />
        
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/hvem-er-vi" element={<WhoWeAre />} />
            <Route path="/midtgaarden" element={<MidtgaardenPage />} />
            <Route path="/personale" element={<StaffPage />} />
            <Route path="/praktiske-oplysninger" element={<PracticalInfoPage />} />
            
            <Route path="/behandling" element={<TreatmentOverviewPage />} />
            <Route path="/doegnbehandling" element={<TreatmentOverviewPage />} />
            <Route path="/dobbeltdiagnose" element={<DobbeltdiagnosePage />} />
            <Route path="/behandling/dobbeltdiagnose" element={<DobbeltdiagnosePage />} />
            <Route path="/behandling/komorbiditet" element={<DobbeltdiagnosePage />} />
            <Route path="/botilbud" element={<BotilbudPage />} />
            <Route path="/behandling/botilbud" element={<BotilbudPage />} />
            <Route path="/behandling/afgiftning" element={<AfgiftningPage />} />
            <Route path="/afgiftning" element={<AfgiftningPage />} />
            <Route path="/alkoholbehandling" element={<AfgiftningPage />} />
            <Route path="/behandling/alkoholbehandling" element={<AfgiftningPage />} />
            <Route path="/behandling/:slug" element={<TreatmentDetailPage />} />
            
            <Route path="/tilsyn" element={<ApprovalsAndTilsynPage />} />
            <Route path="/priser" element={<PricesPage />} />
            
            <Route path="/paragraf-101-og-paragraf-141" element={<ParagrafPage />} />
            <Route path="/borger" element={<CitizenPage />} />
            <Route path="/fagperson" element={<ProfessionalPage />} />
            <Route path="/midtgaarden-i-sejstrup" element={<SejstrupPage />} />
            <Route path="/halvvejshuset-i-esbjerg" element={<EsbjergPage />} />
            <Route path="/regler" element={<RulesPage />} />
            
            <Route path="/403" element={<ForbiddenPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </main>

        <Footer />
        <FloatingCTA />
      </div>
    </HelmetProvider>
  );
}
